import { useState, useEffect } from "react";

import PropTypes from "prop-types";

import ThreeLevelMessage from "../../utils/ThreeLevelMessage";

import { useTranslation } from "react-i18next";

import CardsDeckCustom from "../../utils/CardsDeckCustom";

import { connect } from "react-redux";

import Container from "react-bootstrap/Container";

import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

import {
  LOG_IN,
  REGISTER,
  WORKSPACE_TYPE_PUBLIC,
  WORKSPACE_TYPE_PRIVATE,
  TOPIC_ICON_PATH,
  TOPIC_IMAGE_PATH_ON_ERROR,
} from "../../constants/stringConstants";

import CustomModal from "../../utils/CustomModal";

import FieldsInForm from "../../utils/FieldsInForm";

import AlertMessage from "../../utils/AlertMessage";

import {
  TOPIC_NAME,
  TOPIC_MULTI_CHECKBOX,
  TOPIC_AUDIENCE,
} from "../../constants/stringConstants";

import {
  createTopicGroup,
  doRestartTopicMessages,
} from "../../actions/topicActions";

import { bindActionCreators } from "redux";
import { isIPad13 } from "react-device-detect";

const MySelection = ({
  mySelectionTopics,
  loggedIn,
  createTopicGroup,
  userToken,
  currentWorkspace,
  curatedRegHubTopics,
  user,
  topicErrorMessage,
  topicSuccessMessage,
  doRestartTopicMessages,
}) => {
  const { t } = useTranslation();
  const [checkBoxCheckedIds, setCheckBoxCheckedIds] = useState([]);
  const [selectTopicAudience, setSelectTopicAudience] = useState("private");
  const [submitOccurred, setSubmitOccurred] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [
      createNewGroupOfTopicsShown,
      setCreateNewGroupuOfTopicsShown,
    ] = useState(false),
    argsForFields = {
      findFormErrors: (form) => {
        const { TOPIC_NAME } = form;
        const newErrors = {};

        if (!TOPIC_NAME || TOPIC_NAME === "")
          newErrors.TOPIC_NAME = t("topicNameIsAMandatoryField");
        else if (TOPIC_NAME.length > 48)
          newErrors.TOPIC_NAME = t("topicNameCantBeLongerThan48Charachteres");

        if (
          !checkBoxCheckedIds.length &&
          curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview").length
        )
          newErrors.TOPIC_MULTI_CHECKBOX = t("youMustSelectAtLeastOneTopic");
        else if (
          checkBoxCheckedIds.length > 12 &&
          curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview").length
        )
          newErrors.TOPIC_MULTI_CHECKBOX = t("youCantSelectMoreThan12Topics");

        if (!selectTopicAudience || selectTopicAudience === "")
          newErrors.TOPIC_AUDIENCE = t("topicAudienceIsAMandatoryField");

        return newErrors;
      },
      fields: [
        {
          name: TOPIC_NAME,
          type: "text",
          className: "register-login-text-field",
          required: true,
          classnameofgroup: "register-login-text-field-group",
          label: t("name"),
          placeholder: t("egEuropeanBakingRegulations"),
        },
        {
          name: TOPIC_AUDIENCE,
          type: "select",
          className: "register-login-text-field",
          options: [
            {
              description: t("privateWorkspace"),
              value: WORKSPACE_TYPE_PRIVATE,
            },
            { description: t("publicWorkspace"), value: WORKSPACE_TYPE_PUBLIC },
          ],
          required: true,
          disabled: currentWorkspace.WORKSPACE_TYPE === WORKSPACE_TYPE_PRIVATE,
          displayProperty: "description",
          valueProperty: "value",
          label: t("groupAudience"),
        },
        {
          name: TOPIC_MULTI_CHECKBOX,
          type: "multi-checkbox",
          className: "register-login-text-field",
          required: false,
          classnameofgroup: "register-login-text-field-group",
          label: t("selectTopicsToBaseYourTopicOn"),
          data: curatedRegHubTopics.filter((o) => o.TOPIC_STATUS !== "preview"),
          displayProperty: TOPIC_NAME,
          valueProperty: TOPIC_NAME,
          imageProperty: TOPIC_ICON_PATH,
          replaceImageProperty: TOPIC_IMAGE_PATH_ON_ERROR,
        },
      ],
      onSubmit: (values) => {
        let topic_search = "";

        checkBoxCheckedIds.forEach((o) => (topic_search += o + ";"));

        createTopicGroup(
          userToken,
          values.TOPIC_NAME,
          topic_search,
          values.TOPIC_AUDIENCE
            ? values.TOPIC_AUDIENCE
            : WORKSPACE_TYPE_PRIVATE,
          user.USER_EMAIL
        );
      },
      onCheckBoxChanged: (TOPIC_NAME) => {
        let found = checkBoxCheckedIds.find((el) => {
          return el === TOPIC_NAME;
        });

        if (found) {
          setCheckBoxCheckedIds(
            checkBoxCheckedIds.filter((o) => o !== TOPIC_NAME)
          );
        } else {
          checkBoxCheckedIds.push(TOPIC_NAME);
          setCheckBoxCheckedIds(checkBoxCheckedIds);
        }
      },
      onSelectBoxChanged: (TOPIC_AUDIENCE) => {
        setSelectTopicAudience(TOPIC_AUDIENCE);
      },
      classNameReactFormal: "register-login-react-formal",
      classNameForm: "register-login-react-form",
    };

  useEffect(() => {
    if (topicErrorMessage) {
      setFailureMessage(topicErrorMessage);
    }

    if (topicSuccessMessage) {
      setSuccessMessage(topicSuccessMessage);
    }
  }, [
    topicErrorMessage,
    setFailureMessage,
    setSuccessMessage,
    topicSuccessMessage,
  ]);

  return (
    <>
      <ThreeLevelMessage
        classNameOfContainer="three-level-message-container"
        classNameOfLevel1="three-level-message-container1 fs-21"
        classNameOfLevel2="three-level-message-container2 fs-12"
        classNameOfLevel3="three-level-message-container3 cursor-pointer fs-12"
        textOfLevel1={t("mySelectionHeadline")}
        textOfLevel2={t("mySelectionSubHeadline")}
      />
      {!loggedIn ? (
        <Container className="three-level-message-with-register topic three-level-message-with-my-selection">
          <div className="three-level-message">
            <span className="three-lvl-msg-with-register-message fs-20">
              {t("thisIsAFeatureAvailableForRegisteredUsersOnly")}
            </span>
            <Link to={REGISTER}>
              <Button
                as="input"
                type="button"
                value={t("register")}
                variant="cyan-green"
                className="header-button three-level-rgst-button fs-14"
              />
            </Link>
            <span className="three-level-msg-logIn-container">
              <span className="three-lvl-msg-log-in-first-label">
                {t("haveAnAccount")}
              </span>
              <Link to={LOG_IN}>
                <span className="three-lvl-msg-log-in-second-label cursor-pointer">
                  {" " + t("logIn")}
                </span>
              </Link>
            </span>
          </div>
        </Container>
      ) : (
        <CardsDeckCustom
          classNameOfCard="homepage-card apply-border-white-color"
          classNameOfCardsColumns={
            isIPad13
              ? "homepage-cards-for-iPad homepage-cards-columns"
              : "homepage-cards-columns"
          }
          classNameOfOverlay="homepage-card-overlay"
          cards={mySelectionTopics}
          setCreateNewGroupuOfTopicsShown={setCreateNewGroupuOfTopicsShown}
          fromMySelection={true}
          loggedIn={loggedIn}
          userEmail={user.USER_EMAIL}
          userToken={userToken}
          curatedRegHubTopics={curatedRegHubTopics}
          currentWorkspace={currentWorkspace}
        />
      )}
      <CustomModal
        titleOfModal={t("newGroupOfTopic")}
        positiveButton={t("createGroup")}
        negativeButton={t("cancel")}
        isShown={createNewGroupOfTopicsShown}
        setIsShown={setCreateNewGroupuOfTopicsShown}
        negativeAction={() => setCreateNewGroupuOfTopicsShown(false)}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal reghub-modal-create-new-topic-group"
        positiveAction={() => setSubmitOccurred(true)}
        formId="add-new-topic-group-form"
        content={
          <FieldsInForm
            idOfForm="add-new-topic-group-form"
            fields={argsForFields.fields}
            findFormErrors={argsForFields.findFormErrors}
            classNameForm={argsForFields.classNameForm}
            onSubmit={argsForFields.onSubmit}
            submitOccurred={submitOccurred}
            setSubmitOccurred={setSubmitOccurred}
            onCheckBoxChanged={argsForFields.onCheckBoxChanged}
            onSelectBoxChanged={argsForFields.onSelectBoxChanged}
          />
        }
      />
      {failureMessage ? (
        <AlertMessage
          variant="danger"
          onClose={() => {
            setFailureMessage("");
            doRestartTopicMessages();
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      ) : (
        <div className="display-none" />
      )}
      {successMessage ? (
        <AlertMessage
          variant="success"
          onClose={() => {
            setSuccessMessage("");
            doRestartTopicMessages();
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      ) : (
        <div className="display-none" />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    mySelectionTopics: state.topicReducer.mySelectionTopics,
    loggedIn: state.userReducer.loggedIn,
    userToken: state.configReducer.userToken,
    user: state.userReducer.user,
    currentWorkspace: state.configReducer.currentWorkspace,
    curatedRegHubTopics: state.topicReducer.curatedRegHubTopics,
    topicErrorMessage: state.topicReducer.topicErrorMessage,
    topicSuccessMessage: state.topicReducer.topicSuccessMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createTopicGroup: bindActionCreators(createTopicGroup, dispatch),
    doRestartTopicMessages: bindActionCreators(
      doRestartTopicMessages,
      dispatch
    ),
  };
};

MySelection.propTypes = {
  mySelectionTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: PropTypes.string,
      SUBSCRIPTION: PropTypes.string,
      TOPIC_AUDIENCE: PropTypes.string,
      TOPIC_ICON_PATH: PropTypes.string,
      TOPIC_ID: PropTypes.number,
      TOPIC_NAME: PropTypes.string,
      TOPIC_SEARCHTAGS: PropTypes.string,
      TOPIC_STATUS: PropTypes.string,
    })
  ),
  loggedIn: PropTypes.bool.isRequired,
  createTopicGroup: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  currentWorkspace: PropTypes.shape({
    WORKSPACE_TYPE: PropTypes.string,
  }).isRequired,
  curatedRegHubTopics: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  user: PropTypes.shape({
    USER_EMAIL: PropTypes.string,
  }).isRequired,
  topicErrorMessage: PropTypes.string.isRequired,
  topicSuccessMessage: PropTypes.string.isRequired,
  doRestartTopicMessages: PropTypes.func.isRequired,
};

MySelection.defaultProps = {
  mySelectionTopics: PropTypes.arrayOf(
    PropTypes.shape({
      CREATED_BY: "",
      SUBSCRIPTION: "FALSE",
      TOPIC_AUDIENCE: "",
      TOPIC_ICON_PATH: "",
      TOPIC_ID: 0,
      TOPIC_NAME: "",
      TOPIC_SEARCHTAGS: "",
      TOPIC_STATUS: "",
    })
  ),
  loggedIn: false,
  createTopicGroup: () => {},
  currentWorkspace: {
    WORKSPACE_TYPE: "",
  },
  curatedRegHubTopics: [],
  user: {},
  topicErrorMessage: "",
  topicSuccessMessage: "",
  dispatch: () => {},
  doRestartTopicMessages: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(MySelection);
